<template>
  <div>
    <div class="mb-6 flex flex-nowrap justify-between">
      <h1 class="mr-3 text-2xl text-gray-777 font-roboto uppercase">Consulta Online</h1>
    </div>
    <data-table
      v-if="loadTable"
      v-model:columns="columns"
      :route="'/patients/appointments/' + patient.id"
      no-data-label="Nenhuma consulta cadastrada"
      no-result-label="Nenhuma consulta encontrada"
    >
    <template #table.cell.content.actions="{ value, row }">
      <div class="inline-grid grid-cols-1 gap-4 ">
        <span v-if="row.openRoom && user.role == 2 && user.professional.id == row.professional.id" @click="openRoom(row)"><font-awesome-icon icon="fa-video" class="text-gray-500 text-lg cursor-pointer" /></span>
      </div>
    </template>
    <template #grid.content.body.actions="{ value, row }">
      <div class="inline-grid grid-cols-1 gap-4 ">
        <span v-if="row.openRoom && user.role == 2 && user.professional.id == row.professional.id" @click="openRoom(row)"><font-awesome-icon icon="fa-video" class="text-gray-500 text-lg cursor-pointer" /></span>
      </div>
    </template>
    </data-table>
  </div>
</template>

<script>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import DataTable from '@/Shared/DataTable'

export default {
  inject: ['patient', 'openModalJitsi'],
  components: {
    DataTable,
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  data() {
    return {
      loadTable: true,
      appointment: {},
      columns: [
        {
          uniqid: 'professional_name',
          label: 'Profissional',
          field: 'professional_user.name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => `${row.professional.user.name}`,
        },
        {
          uniqid: 'date_start',
          label: 'Data da Consulta',
          field: 'date_start',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => this.$filters.formatDateTime(row.date_start),
        },
        {
          uniqid: 'duration',
          label: 'Duração da consulta',
          field: 'duration',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => `${row.duration}`,
        },
        {
          uniqid: 'specialty',
          label: 'Especialidade',
          field: 'specialties.name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.specialty ? row.specialty.name : ''
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: this.user.role == 2,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  methods: {
    openRoom(item) {
      this.appointment = item;
      this.openModalJitsi(this.appointment);
    }
  },
}
</script>